import { render, staticRenderFns } from "./PaymentSideInfo.vue?vue&type=template&id=9d355cf6"
import script from "./PaymentSideInfo.vue?vue&type=script&lang=js"
export * from "./PaymentSideInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports